import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCoins, faFileInvoice, faPercent} from '@fortawesome/free-solid-svg-icons';
import DashboardShell from './DashboardShell';
import {useDashboardData} from './useDashboardData';
import {StatTile, TrendLineChart, DonutBreakdown} from '../../../components/charts';

type RevenueData = {
    total_revenue: number;
    outstanding_invoices: number;
    revenue_by_day: {date: string; total: number}[];
    transaction_success_rate: number;
    transactions_by_status: {name: string; value: number}[];
};

/** Revenue & Billing (P1) - execution_strategy_activity_tracker.md Phase
 * 4.3. InvoicePayment/IndexPayTransaction already had real amounts - never
 * summed or charted before this. */
const RevenueBillingDashboard: React.FC = () => {
    const {data, loading, error} = useDashboardData<RevenueData>('/admin-dashboard/dashboards/revenue-billing/');

    return (
        <DashboardShell
            title="Revenue & Billing"
            subtitle="Payments received and payment-gateway performance"
            loading={loading}
            error={error}
        >
            {data && (
                <>
                    <div className="row g-3 mb-4">
                        <div className="col-md-4">
                            <StatTile icon={faCoins} label="Total Revenue" value={data.total_revenue.toLocaleString()} color="#0ab39c"/>
                        </div>
                        <div className="col-md-4">
                            <StatTile icon={faFileInvoice} label="Outstanding Invoices" value={data.outstanding_invoices} color="#f7b84b"/>
                        </div>
                        <div className="col-md-4">
                            <StatTile icon={faPercent} label="Transaction Success Rate" value={`${data.transaction_success_rate}%`} color="#405189"/>
                        </div>
                    </div>

                    <div className="row g-3">
                        <div className="col-lg-8">
                            <div className="uz-panel h-100">
                                <div className="uz-panel-header"><span className="uz-section-title">Revenue (30 days)</span></div>
                                <div className="uz-panel-body">
                                    <TrendLineChart
                                        data={data.revenue_by_day}
                                        xKey="date"
                                        yKey="total"
                                        valueFormatter={(v) => v.toLocaleString()}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="uz-panel h-100">
                                <div className="uz-panel-header"><span className="uz-section-title">Transactions by Status</span></div>
                                <div className="uz-panel-body">
                                    <DonutBreakdown data={data.transactions_by_status}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </DashboardShell>
    );
};

export default RevenueBillingDashboard;
